module.exports = __webpack_public_path__ + "img/lsnycy.4d5e170b.png";